<script lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { type IconValues } from '@gat-ship/icons'
  export interface AvatarTwoLineProps {
    src?: string
    icon?: IconValues | false
    fallback?: string
    loadingId?: string
    title: string
    description: string
    class?: HTMLAttributes['class']
    iconClass?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import AvatarIcon from './avatar-icon.vue'
  import { cn, useAppLoading } from '@gat-ship/vue-components'

  const props = defineProps<AvatarTwoLineProps>()

  const { isLoading } = useAppLoading()
</script>
<template>
  <div :class="cn('flex w-full min-w-0 items-center gap-3.5', props.class)">
    <avatar-icon
      v-if="props.icon !== false || props.src !== undefined"
      :icon="props.icon || undefined"
      :loading-id="props.loadingId"
      :src="props.src"
      :fallback="props.fallback"
      :class="props.iconClass"
    />
    <div
      class="flex min-w-0 flex-col items-start justify-center gap-0.5 overflow-hidden"
    >
      <div class="min-w-0 truncate text-sm font-medium leading-tight">
        {{ title }}
      </div>
      <div class="text-soft min-w-0 truncate text-xs leading-tight">
        {{ description }}
      </div>
    </div>
    <slot
      name="actions"
      :class="'text-primary dark:text-primary hover:text-primary/80 group inline-flex h-5 items-center justify-center gap-1 whitespace-nowrap text-sm underline decoration-transparent underline-offset-[3px] outline-none transition duration-200 ease-out hover:decoration-current focus:outline-none focus-visible:underline disabled:pointer-events-none disabled:text-slate-300 disabled:no-underline'"
    />
  </div>
</template>
